exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action[data-v-6e2a63b0] {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: transparent;\n  border: none;\n  outline: none !important;\n  cursor: pointer;\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 0;\n  margin-bottom: 1.5rem;\n  margin-left: auto;\n}\n.action .svg-icon[data-v-6e2a63b0] {\n  height: 2.5rem;\n  width: 2.5rem;\n  fill: #E42034;\n  stroke: transparent;\n  margin-right: 0;\n}", ""]);

// exports
